export default __webpack_public_path__ + "static/media/bus.fea6f22f.jpg";